/**
 * One tractor-day in the span table: the two lanes from the day's cells,
 * 00:00 at the left edge and 24:00 at the right, so a busy midday reads as a
 * block in the middle. A click opens that day.
 */
import React from "react";
import { Link } from "react-router-dom";
import { styled } from "styled-components";
import { segmentsFromCells } from "./cells";
import { Lane, Segments } from "./lanes";
import { FleetDay } from "./types";

interface DayCellProps {
  day: FleetDay;
  displayName: string;
  to: string;
}

const DayCell: React.FC<DayCellProps> = ({ day, displayName, to }) => (
  <CellLink to={to} aria-label={`${displayName} on ${day.local_day}`}>
    <Lane aria-hidden="true">
      <Segments
        segments={segmentsFromCells(day.cells?.readiness, "readiness")}
      />
    </Lane>
    <Lane $thin aria-hidden="true">
      <Segments segments={segmentsFromCells(day.cells?.activity, "activity")} />
    </Lane>
  </CellLink>
);

export default DayCell;

const CellLink = styled(Link)`
  display: flex;
  flex-direction: column;
  gap: 3px;
  text-decoration: none;
  border-radius: 4px;
  &:hover > div,
  &:focus-visible > div {
    outline: 2px solid #0069ff;
  }
`;
